'use client';

import { c as _c } from "react/compiler-runtime";
import { BuilderBlocks } from '@builder.io/react';
import { Container } from '@src/components/Container/Container';
import { type RailProps } from '@src/components/Rail/Rail.props';
import { RailCarousel } from '@src/components/Rail/RailCarousel/RailCarousel';
import { RailGrid } from '@src/components/Rail/RailGrid';
import { RailItemContextProvider } from '@src/components/Rail/RailItemContext';
import { useBreakpoints } from '@src/utils/breakpoints.util';
import { getBuilderPreviewMode } from '@src/utils/builder.util';
import { cn } from '@src/utils/tailwind';
export const Rail = props => {
  const $ = _c(15);
  const {
    blocksTop,
    builderBlock,
    columnsDesktop,
    columnsMobile,
    imageStyle,
    items,
    previewMode,
    slug,
    stackOnDesktop,
    stackOnMobile
  } = props;
  const {
    edit
  } = getBuilderPreviewMode();
  const breakpoints = useBreakpoints();
  const isMobile = breakpoints.isMobile || breakpoints.isTablet;
  const isPreviewing = edit && previewMode;
  const isCarouselVisible = isMobile && !stackOnMobile || !isMobile && !stackOnDesktop;
  const showCarousel = !isPreviewing && isCarouselVisible;
  const renderItemContainer = () => showCarousel ? <RailCarousel items={items} columnsDesktop={columnsDesktop} columnsMobile={columnsMobile} isPreviewing={isPreviewing} builderBlock={builderBlock} imageStyle={imageStyle} slug={slug} /> : <RailGrid items={items} columnsDesktop={columnsDesktop} columnsMobile={columnsMobile} isPreviewing={isPreviewing} builderBlock={builderBlock} imageStyle={imageStyle} slug={slug} />;
  const t0 = "flex flex-col";
  const T0 = Container;
  const t1 = cn({
    "mb-8": isPreviewing && !showCarousel
  });
  let t2;
  if ($[0] !== blocksTop || $[1] !== builderBlock?.id) {
    t2 = blocksTop?.map((t3, index) => {
      const {
        blocks
      } = t3;
      return <BuilderBlocks key={index} parentElementId={builderBlock?.id} blocks={blocks} dataPath={`component.options.blocksTop.${index}.blocks`} />;
    });
    $[0] = blocksTop;
    $[1] = builderBlock?.id;
    $[2] = t2;
  } else {
    t2 = $[2];
  }
  let t3;
  if ($[3] !== slug || $[4] !== t2) {
    t3 = <RailItemContextProvider slug={slug} position={0}>{t2}</RailItemContextProvider>;
    $[3] = slug;
    $[4] = t2;
    $[5] = t3;
  } else {
    t3 = $[5];
  }
  let t4;
  if ($[6] !== T0 || $[7] !== t1 || $[8] !== t3) {
    t4 = <T0 className={t1}>{t3}</T0>;
    $[6] = T0;
    $[7] = t1;
    $[8] = t3;
    $[9] = t4;
  } else {
    t4 = $[9];
  }
  let t5;
  if ($[10] !== renderItemContainer) {
    t5 = renderItemContainer();
    $[10] = renderItemContainer;
    $[11] = t5;
  } else {
    t5 = $[11];
  }
  let t6;
  if ($[12] !== t4 || $[13] !== t5) {
    t6 = <div className={t0}>{t4}{t5}</div>;
    $[12] = t4;
    $[13] = t5;
    $[14] = t6;
  } else {
    t6 = $[14];
  }
  return t6;
};